import React from 'react';
import { UploadOutlined } from '@ant-design/icons';
import type { UploadProps } from 'antd';
import { Button, Upload } from 'antd';
import { ContainerUpload } from './styles';
import { ButtonType } from 'antd/es/button';
import { useI18n } from '../../shared/i18n';

interface UploadButtonProps extends UploadProps {
  colorButton?: string;
  colorText?: string;
  typeButton?: ButtonType;
  label?: string;
}
export const AUpload: React.FC<UploadButtonProps> = ({
  colorButton,
  colorText,
  typeButton,
  label,
  ...res
}) => {
  const { t } = useI18n();

  return (
    <ContainerUpload>
      <Upload {...res}>
        <Button
          icon={<UploadOutlined />}
          type={typeButton ?? 'primary'}
          style={{ backgroundColor: colorButton, color: colorText }}
        >
          {label ?? t('upload.defaultLabel')}
        </Button>
      </Upload>
    </ContainerUpload>
  );
};
